import React from 'react';
import { useLiveCodes, findById, getState } from '../discountStore';
import { headlineOf, offerWords, shareable, stateOf, STATE_LABEL } from '../data/codes';
import { linkFor } from '../links';

/**
 * The email Offer section's code: one of the salon's live codes, never typed
 * (Marketing › Discounts). Picking one fills in what it's worth, what it
 * covers, the end date, the small print and a booking link that applies the
 * code. A code that has since ended or been paused is called out.
 */
export const emailOfferFor = (code) => {
  const w = offerWords(code);
  return {
    code: code.code,
    codeId: code.id,
    value: w.value,
    subtitle: w.service,
    expiry: w.dates,
    terms: w.small,
    buttonUrl: linkFor(code, 'email'),
  };
};

export default function EmailCodeField({ id, value, codeId, onPick }) {
  const { codes, loaded } = useLiveCodes();
  const current = codeId ? (findById(codeId) || (getState().codes || []).find((c) => c.code === value)) : null;
  const live = current && shareable(current);
  const stale = !!value && loaded && !live;
  return (
    <>
      <select
        id={id}
        className="se-input"
        value={live ? current.id : ''}
        onChange={(e) => {
          const v = e.target.value;
          if (!v) { onPick({ code: '', codeId: '' }); return; }
          const code = codes.find((c) => c.id === v);
          if (code) onPick(emailOfferFor(code));
        }}
      >
        <option value="">{value && !live ? `${value} (not a live code)` : 'No code'}</option>
        {codes.map((c) => <option key={c.id} value={c.id}>{`${c.code}: ${headlineOf(c)}`}</option>)}
      </select>
      {stale && (
        <p className="se-hint se-hint--warn" role="alert">
          {current ? `${value} is ${STATE_LABEL[stateOf(current)].toLowerCase()}, so clients can’t use it. Pick a live code or choose No code.` : `${value} isn’t one of your live codes, so clients can’t use it. Pick a live code or choose No code.`}
        </p>
      )}
      {loaded && !codes.length && <p className="se-hint">No live codes yet. Make one in Marketing, Discounts, and it shows here.</p>}
    </>
  );
}
